import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { KingUser } from '../../interfaces/king.interface';
import { SkinsListComponent } from '@core/components/skins-list/skins-list.component';
import { ModalService } from '@features/modals/services/modal.service';
import { CostComponent } from '@core/components/cost/cost.component';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-king-side-bottom',
  templateUrl: './king-side-bottom.component.html',
  styleUrls: ['./king-side-bottom.component.scss'],
  standalone: true,
  imports: [SkinsListComponent, CostComponent, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.king]': '!isChallenger()',
    '[class.challenger]': 'isChallenger()',
  },
})
export class KingSideBottomComponent {
  isChallenger = input<boolean>(false);
  user = input<KingUser | null>(null);
  vault = signal<boolean>(false);

  // Mobile spoiler expanded state
  expanded = signal<boolean>(false);

  toggleExpanded() {
    this.expanded.update((v) => !v);
  }

  kingSkins = computed(
    () => this.user()?.skins.filter((skin) => {
      return (skin?.type as unknown as number) === (this.vault() ? 1 : 0);
    }) ?? []
  );

  skinsValue = computed(() =>
    this.kingSkins().reduce((acc, skin) => acc + skin.price, 0)
  );

  private readonly modalService = inject(ModalService);

  toggleVault(value: boolean) {
    this.vault.set(value);
  }

  openModal() {
    this.modalService.openModal('DepositKingModal');
  }
}
